import * as moment from 'moment/moment';
import { orderBy, sortBy, sortedUniq } from 'lodash';
import { ApiServiceService } from '../api-service.service';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Keys, StorageService } from '../service/storage.service';
import { DataSource } from '../portfolio-creation/manualinvest/data-source';
import { LenderPassbookRecord } from '../model/lender-passbook-record';
import { LenderDetailsService } from '../service/lender-details.service';
import { ConfigService } from '../service/config.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-lenderpassbook',
    templateUrl: './lenderpassbook.component.html',
    styleUrls: ['./lenderpassbook.component.css'],
    providers: [ApiServiceService, LenderDetailsService],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*', minHeight: "*" })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class LenderpassbookComponent implements OnInit {

    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    public portfolio: any;
    transactionTypes: string[];
    data: LenderPassbookRecord[];
    transactionTypeFilter: string;
    dataSource: DataSource = new DataSource();
    passbookDateRangeFilter: { fromDate: Date, toDate: Date };
    displayedColumns: any = ['timestamp', 'transactionType', 'amount', 'description'];
    maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    fromDate = new Date();
    expandedElement: LenderPassbookRecord | null;
    shouldShowPdfOption: boolean = false;

    private configService: ConfigService;
    private lenderDetailsService: LenderDetailsService;

    public isMobile: boolean = false;
    screenWidth: number;

    constructor(private storageService: StorageService, lenderDetailsService: LenderDetailsService, configService: ConfigService) {
        this.lenderDetailsService = lenderDetailsService;
        this.configService = configService;
        this.fromDate = moment().subtract(30, 'days').toDate();
        this.passbookDateRangeFilter = {
            fromDate: moment().year(2017).startOf('year').toDate(),
            toDate: moment().toDate()
        };
    }
    ngAfterViewInit() {
        this.screenWidth = window.innerWidth;
        this.isMobile = (<any>window).innerWidth < 500;
        if (this.isMobile) {
            this.displayedColumns = ['timestamp', 'transactionType', 'amount', 'accordion_arrow'];
        }
    }
    async ngOnInit() {
        const fromDate = moment().subtract(30, 'days').toDate().toISOString();
        const toDate = moment().toDate().toISOString();
        this.data = await this.lenderDetailsService.getPassbook(this.storageService.getItem(Keys.LENDER_ID), fromDate, toDate);
        const allTransactionTypes = this.data.map(item => item.getDisplayableTransactionType());
        this.transactionTypes = sortedUniq(sortBy(allTransactionTypes, transactionType => transactionType.toLowerCase()));

        this.data = this.sortDataByTimestamp(this.data);
        this.dataSource.data = this.data;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.shouldShowPdfOption = await this.getPassbookCount();
    }

    changeFromDate(event: MatDatepickerInputEvent<Date>) {
        this.passbookDateRangeFilter = {
            fromDate: event.value,
            toDate: this.passbookDateRangeFilter.toDate
        };
    }

    changeToDate(event: MatDatepickerInputEvent<Date>) {
        this.passbookDateRangeFilter = {
            fromDate: this.passbookDateRangeFilter.fromDate,
            toDate: event.value
        };
    }

    public getFileDownloadUrl(fileType: string): string {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const token = this.storageService.getItem(Keys.TOKEN);

        return `${this.configService.baseUrl()}passbook/download?lenderId=${lenderId}&profile_id=${profileId}&token=${token}&fileType=${fileType}`;
    }

    public downloadFile(fileUrl: string) {
        //download from mobile app
        let message = {
            action: "download_file",
            url: fileUrl
        }
        let webkit = (window as any).webkit;
        if (webkit) {
            webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));
        } else {
            (<any>window).location.href = fileUrl;
        }
    }

    private async getPassbookCount(): Promise<boolean> {
        try {
            const data: any = await this.lenderDetailsService.getLenderPassbookRecordsCount(this.storageService.getItem(Keys.LENDER_ID));
            if (data && data.lender_info && data.lender_info.length && data.lender_info[0].lenderPassbookCount < 5000) {
                return true;
            }
            return false;
        }
        catch (e) {
            console.log(e);
            return false;
        }
    }

    private sortDataByTimestamp(passbookEntries: LenderPassbookRecord[]): LenderPassbookRecord[] {
        return orderBy(passbookEntries, (entry: any) => {
            return new Date(entry.timestamp);
        }, ['desc']) as any;
    }
}

